
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
    // login(item) {
    //   return axiosPure.post('Auth/Login',item);
    // },
    // listMenus() {
    //   return $axios.get('Auth/listMenus');
    // },
    
     GetFormName(formId) {
        return $axios.get('Form/GetFormName/'+formId);
    },
        KullaniciFormBilgisi(formId) {
        return $axios.get('Form/KullaniciFormBilgisi/'+formId);
    },
    listForm() {
        return $axios.get('Form');
    },
    AdminFormlari(){
        return $axios.get('Form/AdminFormlari');
    },
    KullaniciDoldurulacakFormlar() {
        return $axios.get('Form/KullaniciDoldurulacakFormlar');
    },
    KullaniciDegerlendirelecekFormlar() {
        return $axios.get('Form/KullaniciDegerlendirelecekFormlar');
    },
    save(item) {
        return $axios.post('Form', item);
    },
    update(id, item) {
        return $axios.put('Form/' + id, item);
    },
        delete(item) {
        return $axios.delete('Form/'+item.formId);
    },
    listFormResultDataItems(id) {
        return $axios.get('Form/Data/' + id);
    },
        listFormResultDataItemsByNo(id,no) {
        return $axios.get('Form/Data/' + id+'?no='+no.toString());
    },
        listReportData(id) {
        return $axios.get('Form/ReportData/' + id);
    },
    listFormItems(formId) {
        return $axios.get('Form/listFormItems/' + formId);
    },
        listFormItemsAdmin(formId) {
        return $axios.get('Form/listFormItemsAdmin/' + formId);
    },
        listFormItemsEdit(formId) {
        return $axios.get('Form/listFormItemsEdit/' + formId);
    },
    ItemsAdd(formId, selectedFields) {
        return $axios.post('Form/ItemsAdd/' + formId, selectedFields);
    },
        formKopyala(formId) {
        return $axios.get('Form/FormKopyala/' + formId);
    },
    onaylama(guid,onayDurumDTO){
          return $axios.put('FormSaved/onaylama/' + guid, onayDurumDTO);
    },
        listOnIzlemeFormItems(formId) {
        return $axios.get('Form/listOnIzlemeFormItems/' + formId);
    },
          listYoneticilerByFormId(formId) {
        return $axios.get('Form/listYoneticilerByFormId/' + formId);
    },
              formYetkilendirme(data) {
                //data:{formId:"",tc:""}
        return $axios.post('Form/formYetkilendirme',data);
    },
    deleteYoneticiFormByYoneticiFormId(yoneticiFormId){
         return $axios.delete('Form/DeleteYoneticiFormByYoneticiFormId/'+yoneticiFormId);
    },
        anketRapor(formId) {
        return $axios.get('Form/anketRapor/' + formId);
    },
    listCanliFormOgeByFormId(formId){
          return $axios.get('Form/listCanliFormOgeByFormId/' + formId); 
    },
        listCanliAnketFormlari(){
          return $axios.get('Form/canliAnketFormlari/'); 
    },
    AnketDashboardReport(date,birimId){
        let dateStr=date ?? "";
        let birimStr=birimId ?? "";
        
        return $axios.get('Form/AnketDashboardReport?start='+dateStr+'&birimId='+birimStr ); 
        // if (date!=null) {
        //     return $axios.get('Form/AnketDashboardReport?start='+date ); 
        // }
        // else{
        //     return $axios.get('Form/AnketDashboardReport?start='); 
        // }
          
    }

    //   delete(birim) {
    //     return $axios.delete('/Birim/delete/'+birim.id);

    //   }
};